const initModal = () =>
{
  const userButtons = document.querySelectorAll('.tools__account');
  const cabinetModal = document.querySelector('.modal--cabinet');
  const modalOverlay = document.querySelector('.modal-overlay');

  if(userButtons)
  {
    const openModal = (e) =>
    {
      e.preventDefault();
      document.body.style.top = `-${window.scrollY}px`;
      cabinetModal.classList.remove('visually-hidden');
      modalOverlay.classList.remove('visually-hidden');
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
      if(scrollWidth)
      {
        document.body.style.paddingRight = `${scrollWidth}px`;
      }
      document.body.classList.add('scroll-lock', 'scroll-lock-ios');
      document.body.addEventListener('click', onClickOutside);
    };

    const closeModal = () =>
    {
      cabinetModal.classList.add('visually-hidden');
      modalOverlay.classList.add('visually-hidden');
      document.body.classList.remove('scroll-lock', 'scroll-lock-ios');
      document.body.removeEventListener('click', onClickOutside);
      const scrollY = document.body.style.top;
      document.body.style.paddingRight = 0;
      document.body.style.top = null;
      window.scroll({
        top: parseInt(scrollY || '0', 10) * -1,
        behavior: 'instant',
      });
    };

    const onClickOutside = (e) =>
    {
      if(e.target === modalOverlay || e.target === cabinetModal)
      {
        closeModal();
      }
    };

    userButtons.forEach((button) =>
    {
      button.addEventListener('click', openModal);
    });
  }
};

export { initModal };
